import { Outlet } from 'react-router';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import { Box} from '@mui/material';

export default function Layout() {
    return (
        <DashboardLayout>
            <Box sx={{px: 4, py: 4 }} >
                <Outlet />
            </Box>
        </DashboardLayout>
    );
}